import { fetchAreaMembers } from "src/Pages/Company/OrganizationStructure/api";
import { useInfiniteQuery } from "@tanstack/react-query";

const useGetAreaMembers = ({
  areaId,
  structureId,
  companyId,
}: {
  areaId: string;
  structureId: string;
  companyId: string;
}) =>
  useInfiniteQuery({
    queryKey: ["areaEmployees", areaId],
    queryFn: ({ pageParam }: { pageParam: string | null }) =>
      fetchAreaMembers({ pageParam, areaId, structureId, companyId }),
    initialPageParam: null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
  });

export default useGetAreaMembers;
